import * as yup from 'yup';

const cnpjRegex = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/;

yup.addMethod(yup.string, 'cnpj', function () {
  return this.test('cnpj', function () {
    const { path, createError } = this;
    const field = document.getElementsByName(path)[0];
    return new Promise((resolve, reject) => {
      if (field && cnpjRegex.test(field.value)) {
        resolve(true);
      } else {
        reject(createError({ path, message: 'Invalid CNPJ', type: 'cnpj' }));
      }
    });
  });
});

yup.addMethod(yup.string, 'select', function () {
  return this.test('select', function () {
    const { path, createError } = this;
    const field = document.getElementsByName('headOffice')[0];
    return new Promise((resolve, reject) => {
      if (field && field.value) {
        resolve(true);
      } else {
        reject(
          createError({ path, message: 'field is required', type: 'required' })
        );
      }
    });
  });
});

const schema = yup.object().shape({
  name: yup
    .string()
    .required()
    .trim(),
  cnpj: yup.string().cnpj(),
  type: yup
    .string()
    .required()
    .trim(),
  headOffice: yup.string().when('type', {
    is: value => value === 'F',
    then: yup.string().select()
  }),
  description: yup
    .string()
    .required()
    .trim(),
  userLicenses: yup
    .string()
    .required()
    .trim(),
  ipRecorderLicenses: yup
    .string()
    .required()
    .trim()
});

export default schema;
